import React from 'react';

import {useTranslation} from "react-i18next";
import ProgressBar from 'react-bootstrap/ProgressBar';
import Helmet from "react-helmet";
import {FaAndroid, FaApple, FaCheck, FaFile, FaGit, FaGlobe, FaRegCheckCircle, FaTelegram} from "react-icons/fa";
import {FaCircleH} from "react-icons/fa6";

function DetailTrackingProjectPage(props) {

    const {t, i18n} = useTranslation()

    return (<div className={'container mt-5'}>

        <Helmet>
            <title>Yaroslav Lukyanchuk</title>
            <meta name="description" content="Yaroslav Lukyanchuk"/>
        </Helmet>

        <div className="d-flex flex-wrap">

            <div className="col-md-3 p-3">
                <h1>Project Name</h1>
                <small>
                    service name
                </small>

                <hr/>

                <div className="flex flex-wrap">
                    <a className={'text-sm nav-link'}>
                        <FaGit size={18}/> <small>/project-name</small>
                    </a>
                    <a className={'text-sm nav-link'}>
                        <FaGlobe size={18}/> <small> doamin.com</small>
                    </a>
                    <a className={'text-sm nav-link'}>
                        <FaApple size={18}/> <small> ios app</small>
                    </a>
                    <a className={'text-sm nav-link'}>
                        <FaAndroid size={18}/> <small> apk</small>
                    </a>
                </div>

                <hr/>

                <div className="d-flex align-items-center justify-content-around">
                    <a href="/project/tracking" className={'nav-link'}>
                        <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                             xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M5 12h14M5 12l4-4m-4 4 4 4"/>
                        </svg>
                        Exit
                    </a>
                    <hr className={'vr'}/>
                    <small className="text-secondary">Access code: <b>{props.code}</b></small>
                </div>
            </div>
            <div className="border-0 col-md-6 col-12 m-auto">
                <div className="sticky-top p-3 liquid-glass">
                    <div className={'d-flex justify-content-between align-items-end'}>
                        <h2>in process</h2>
                        <small>deadline date</small>
                    </div>
                    <br/>
                    <ProgressBar now={12} label={`${12}%`} variant="dark"/>
                </div>

                <div className="overflow-auto" style={{maxHeight: '75vh'}}>
                    {Array.from({length: 5}, (_, index) => (
                        <div className="history mt-5">
                            <div className="item-history pt-3">
                                <small className="text-secondary">
                                    22.11.2024
                                </small>
                                <div className="d-flex align-items-center justify-content-between">
                                    <h3>
                                        Create project
                                    </h3>
                                    <small className="text-secondary lead">
                                        +12%
                                    </small>
                                </div>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deleniti, deserunt eaque
                                    enim esse explicabo labore libero mollitia nisi officia quo, totam vel, voluptatem.
                                    Animi autem beatae, odio possimus quasi velit.
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
            <div className="col-md-3">
                <div className="border- m-3 mt-0 p-3">
                    <h3>
                        Docs
                    </h3>
                    <a className={'text-sm nav-link'}>
                        <FaFile size={18}/> <small> Contract (date) pdf</small>
                    </a>
                    <div className="d-flex align-items-center justify-content-between">
                        <a className={'text-sm nav-link'}>
                            <FaFile size={18}/> <small> Tech Tasks (date) pdf</small>
                        </a>
                        <small className={'text-success'}><FaRegCheckCircle size={18} color={'#2b8d5c'}/> Approved</small>
                    </div>
                    <hr/>
                    <h3>
                        Payments
                    </h3>
                    <div className="d-flex align-items-center justify-content-between">
                        <a className={'text-sm nav-link'}>
                            <FaFile size={18}/> <small> Invoice (date) pdf</small>
                        </a>
                        <small className={'text-success'}><FaRegCheckCircle size={18} color={'#2b8d5c'}/> Paymented</small>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <a className={'text-sm nav-link'}>
                            <FaFile size={18}/> <small> Invoice (date) pdf</small>
                        </a>
                        <small className={'text-warning'}>Waiting payment</small>
                    </div>
                    <hr/>
                    <button className={'btn btn-dark'}><FaTelegram/> write to Manager</button>
                </div>
            </div>

        </div>
    </div>);
}

export default DetailTrackingProjectPage;
